import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    minHeight: "calc(100vh - 17rem)",
    width: "100%",
    flexDirection: "column",
  },
  description: {
    margin: "1rem 0",
    fontWeight: 500,
  },
  waveBottom: {
    width: "100%",
    "& > img": {
      display: "block",
      width: "100%",
      height: "6rem",
      marginBottom: "3rem"
    },
  },
})